/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NetworkInterfaceInfo
 */
export interface NetworkInterfaceInfo {
    /**
     * Eg Ethernet, Wifi, GSM
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    networkType?: string;
    /**
     * The adapter's MAC address, if available
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    macAddress?: string;
    /**
     * IP address on this interface (eg local IP for Ethernet/Wifi). Not currently available
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    ipAddress?: string;
    /**
     * If NetworkType=Wifi, the ssid. Currently only available for Autel AC. If NetworkType=GSM, the telco provider.
     * @type {string}
     * @memberof NetworkInterfaceInfo
     */
    ssid?: string;
    /**
     * True if this interface is active. For ChargeMate, only Wifi or Ethernet is active at any one time
     * @type {boolean}
     * @memberof NetworkInterfaceInfo
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the NetworkInterfaceInfo interface.
 */
export function instanceOfNetworkInterfaceInfo(
    value: object,
): value is NetworkInterfaceInfo {
    return true;
}

export function NetworkInterfaceInfoFromJSON(json: any): NetworkInterfaceInfo {
    return NetworkInterfaceInfoFromJSONTyped(json, false);
}

export function NetworkInterfaceInfoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): NetworkInterfaceInfo {
    if (json == null) {
        return json;
    }
    return {
        networkType:
            json["networkType"] == null ? undefined : json["networkType"],
        macAddress: json["macAddress"] == null ? undefined : json["macAddress"],
        ipAddress: json["ipAddress"] == null ? undefined : json["ipAddress"],
        ssid: json["ssid"] == null ? undefined : json["ssid"],
        isActive: json["isActive"] == null ? undefined : json["isActive"],
    };
}

export function NetworkInterfaceInfoToJSON(
    value?: NetworkInterfaceInfo | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        networkType: value["networkType"],
        macAddress: value["macAddress"],
        ipAddress: value["ipAddress"],
        ssid: value["ssid"],
        isActive: value["isActive"],
    };
}
